import api from '@app/utils/api';
import qs from 'qs';

export const fetchOwnerDashboardFilters = (params) => {
  return api.get(`/owner/dashboard/filters?${qs.stringify(params)}`);
};

export const fetchOwnerDashboardGlobalView = (params) => {
  return api.get(`/owner/dashboard/global-view?${qs.stringify(params)}`);
};

export const fetchOwnerDashboardCorporates = (params) => {
  return api.get(`owner/dashboard/list/corporates?${qs.stringify(params)}`);
};

export const fetchOwnerDashboardCorporateFacilities = (corporateId, params) => {
  return api.get(
    `owner/dashboard/list/corporates/${corporateId}/facilities?${qs.stringify(
      params
    )}`
  );
};

export const fetchOwnerDashboardCorporateFacilityDetails = (
  corporateId,
  facilityId,
  params
) => {
  return api.get(
    `owner/dashboard/list/corporates/${corporateId}/facilities/${facilityId}?${qs.stringify(
      params
    )}`
  );
};
